import { useLayoutEffect } from 'react';

import { useNovaNavigationSafe } from './nova-navigation-context';

/** Reports browser-exit risk to the standalone adapter. Memory surfaces keep their existing behavior. */
export function useUnsavedNovaChanges(isDirty: boolean) {
  const register = useNovaNavigationSafe()?.registerUnsavedChanges;
  useLayoutEffect(() => {
    if (isDirty) return register?.();
  }, [isDirty, register]);
}
